/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { appWatcherSagas } from './ducks/App';
import { pagesWatcherSagas } from './ducks/Pages';
import { paymentWatcherSagas } from './ducks/Payment';
import { cartWatcherSagas } from './ducks/Cart';
import { chatGptMessageWatcherSagas } from './ducks/CartItem/ChatGptMessage';
import { DonationWatcherSagas } from './ducks/Donation';
import { ExternalCartWatcherSagas } from './ducks/ExternalCart';
import { cartItemSagas } from './ducks/CartItem';
import { attributionWatcherSagas } from './ducks/Attribution';
import { passportWatchersSagas } from './ducks/Passport';
// wallet saga
import { walletWatcherSagas } from '../Member/ducks/Wallet';
import { memberWatchersSagas } from './ducks/Member';

const watcherSagas = [
    ...appWatcherSagas,
    ...pagesWatcherSagas,
    ...paymentWatcherSagas,
    ...DonationWatcherSagas,
    ...ExternalCartWatcherSagas,
    ...cartWatcherSagas,
    ...cartItemSagas,
    ...chatGptMessageWatcherSagas,
    ...attributionWatcherSagas,
    ...walletWatcherSagas,
    ...passportWatchersSagas,
    ...memberWatchersSagas,

];

export default watcherSagas;
